import React, { useState } from "react";

import "./checkBox.css";
import { useEffect } from "react";

const CheckBox = ({
  check,
  onClick,
  id,
  label,
  disabled,
  handleCheck,
  onChange,
  additionStyle,
  features
}) => {
  const [selectedStatus, setSelectedStatus] = useState(check ? check : false);

  // const handleCheck = (e) => {
  //   if (onClick) onClick({ status: e.target.checked, id: id });
  //   setSelectedStatus(e.target.checked ? e.target.checked : false);
  // };

  return (
    <div>
      <input
        type="checkbox"
        className={`styled-checkbox ${additionStyle || ""}`}
        value={label}
        checked={check}
        disabled={disabled}
        onClick={handleCheck}
        id={id}
        onChange={onChange}
      />
      <label htmlFor={id} value={label}>
        {label}
      </label>
      <div className="featureSpacing">{features}</div>
    </div>
  );
};

export default CheckBox;
